/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Book_TitleInputs */

const en_how_page_book_title = /** @type {(inputs: How_Page_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book in two taps.`)
};

const pl_how_page_book_title = /** @type {(inputs: How_Page_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj w dwa dotknięcia.`)
};

/**
* | output |
* | --- |
* | "Book in two taps." |
*
* @param {How_Page_Book_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_book_title = /** @type {((inputs?: How_Page_Book_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Book_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_book_title(inputs)
	return en_how_page_book_title(inputs)
});